import React from 'react'
import { Paper, Stack, Typography, Switch } from '@mui/material'
import { green } from '@mui/material/colors';
import { alpha, styled } from '@mui/material/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

const CheckInInpersonMeet = (props) => {
    const { checked, setChecked, setCheckinData, setSelectedDate, selectedDate, minDate, maxDate, months } = props
    const label = { inputProps: { 'aria-label': 'Color switch demo' } };

    const GreenSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
            color: green[600],
            '&:hover': {
                backgroundColor: alpha(green[600], theme.palette.action.hoverOpacity),
            },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: green[600],
        },
    }));

    const handleSwitchChange = (event) => {
        setChecked(event.target.checked)

        if (!event.target.checked) {
            setCheckinData((prevStates) => ({
                ...prevStates,
                meeting_date: null,
                check_in_date: moment(),
                monthly_ref: months[moment().month()]
            }))
        }
        setSelectedDate(null)
    }
    return (
        <Paper elevation={2} sx={{ mt: 2, mb: 2, p: 2, minHeight: 90 }}>
            <Stack direction='row' spacing={2} alignItems='center'>
                <Stack direction='row' spacing={2} alignItems='center'>
                    <Typography sx={{ fontSize: 14, fontWeight: 'bold' }} variant='span'>In Person Meeting:</Typography>
                    <GreenSwitch
                        {...label}
                        checked={checked}
                        onChange={handleSwitchChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />
                </Stack>
                <LocalizationProvider
                    dateAdapter={AdapterMoment}
                >
                    <DatePicker
                        label="Meeting Date"
                        maxDate={moment(maxDate)}
                        minDate={moment(minDate)}
                        sx={{ visibility: checked ? 'visible' : 'hidden', width: '25%' }}
                        value={selectedDate}
                        onChange={(newValue) => {
                            setSelectedDate(newValue)
                            setCheckinData((prevStates) => ({
                                ...prevStates,
                                meeting_date: newValue,
                                check_in_date: newValue,
                                monthly_ref: months[newValue.month()]
                            }))
                            // getCheckinType(newValue)
                        }}
                        format='YYYY-MM-DD'
                        views={['year', 'month', 'day']}
                        slotProps={{ textField: { fullWidth: true } }}
                    />
                </LocalizationProvider>
            </Stack>
        </Paper>
    )
}

export default CheckInInpersonMeet